import { render, staticRenderFns } from "./TagUsagePerMonth.vue?vue&type=template&id=3d83f1aa"
import script from "./TagUsagePerMonth.vue?vue&type=script&lang=js"
export * from "./TagUsagePerMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports